import React from "react";
import Header from "@containers/LandingPage/Header/Header";
import Footer from "@containers/LandingPage/Footer/Footer";
import "@assets/bootstraps/bootstrap.css";
import "./Home.scss";
import { Outlet } from "react-router-dom";
import { useAuth } from "contexts/AuthContext";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import ChatBox from "@components/ChatBox/ChatBox";

const Home: React.FC = () => {
  const { loading } = useAuth();

  return (
    <div id="body" className={`${loading ? "body-loading" : ""}`}>
      {loading && (
        <div className="loading-wrap">
          <Spin indicator={<LoadingOutlined className="loading-icon" spin />} />
        </div>
      )}
      <Header />
      <Outlet />
      <Footer />
      <ChatBox/>
    </div>
  );
};

export default Home;
